// Delegation also works after a header is re-rendered in the theme editor.
document.addEventListener('pointerover',event=>{
 if(!matchMedia('(hover:hover) and (pointer:fine)').matches)return;
 const group=event.target.closest?.('.jw-nav-group');
 if(!group||group.closest('.jw-nav-mobile'))return;
 for(const other of group.closest('nav').querySelectorAll('.jw-nav-group'))other.open=other===group;
});
document.addEventListener('pointerout',event=>{
 const group=event.target.closest?.('.jw-nav-group');
 if(group&&!group.closest('.jw-nav-mobile')&&!group.contains(event.relatedTarget)&&!group.contains(document.activeElement))group.open=false;
});
document.addEventListener('click',event=>{
 const summary=event.target.closest?.('.jw-nav-group>summary');
 if(summary&&event.detail>0&&!summary.closest('.jw-nav-mobile')&&matchMedia('(hover:hover) and (pointer:fine)').matches){event.preventDefault();summary.parentElement.open=true;}
 for(const group of document.querySelectorAll('.jw-nav-group[open],.jw-nav-mobile[open]'))if(!group.contains(event.target))group.open=false;
});
document.addEventListener('keydown',event=>{
 if(event.key!=='Escape')return;
 const group=event.target.closest?.('.jw-nav-group[open],.jw-nav-mobile[open]');
 if(group){group.open=false;group.querySelector('summary').focus();}
});
